import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import './Classificacao.css';
import * as generic from './generic.js';
import useLoadState from './useLoadState.js';
import useDfpSlot from './useDfpSlot.js';
import Clube from './Clube.js';
import JogoDetail from './JogoDetail.js';

function ClassificacaoHeader(props) {
	const sortTabela = props.sortTabela;
	const SortHeader = function(props) {
		return (
			<div onClick={(e) => sortTabela(e,props.field)} className={"clickable " + (props.className || "")}>
				{props.children}
				{props.sort === props.field ? (props.descending ? <FontAwesomeIcon icon={fa.faCaretDown}/> : <FontAwesomeIcon icon={fa.faCaretUp}/>) : null}
			</div>
		);
	};

	return (
		<div className="header">
			<div className={"row line"}>
				<div className="fixed row"onClick={(e) => props.sortTabela(e,"posicao")} >
					<div className="e0 posicao"></div>
					<div className="e100 clube">Clube</div>
					<SortHeader field="pg" className="number">PG</SortHeader>
				</div>
				<SortHeader field="jg" className="number">J</SortHeader>
				<SortHeader field="vi" className="number">V</SortHeader>
				<SortHeader field="em" className="number">E</SortHeader>
				<SortHeader field="de" className="number">D</SortHeader>
				<SortHeader field="gp" className="number">GP</SortHeader>
				<SortHeader field="gc" className="number">GC</SortHeader>
				<SortHeader field="sg" className="number">SG</SortHeader>
				<SortHeader field="apr" className="number percent">%A</SortHeader>
				{props.has_publico ? (
					<>
						<SortHeader field="pu" className="pu number large">PP</SortHeader>
						<SortHeader field="in" className="number large">I</SortHeader>
						<SortHeader field="iv" className="number percent">%IV</SortHeader>
						<SortHeader field="rl" className="number currency">RL (R$)</SortHeader>
						<SortHeader field="rb" className="number currency">RB (R$)</SortHeader>
					</>
				) :
					null
				}
				{props.isSimulado ? <>
					<div className="select_column">1º</div>
					<div className="select_column">2º</div>
				</> : null}
			</div>
		</div>
	);
}

export default function Classificacao(props) {
	const request = (props.geral ?
		[ { url: "campeonato/" + props.campeonato + "/classificacao_geral", params: { } } ]
	:
		[ { url: "campeonato/" + props.campeonato + "/classificacao", params: { fase: props.fase.id, rodada: props.rodada, simulados: props.simulados } } ]
	);

	const [ state, setState, render ] = useLoadState(

		{ classificacao: [] },

		[ props.fase, props.rodada, props.simulados, props.geral ],

		request,

		(result) => {
			setState({ ...state, classificacao: result[0].result.list, has_publico: result[0].result.has_publico && !props.ignore_publico });
		},

		true
	);

	var slot1 = {
		path: '/102307571/lance_tabelas/sticky_tabelas',
		id: 'div-gpt-ad-3495178-3',
		size: [
			[970,90],
			[728,90],
			[320,50]
		],
		className: 'banner-bottom'
	};

	const dfp = null;//useDfpSlot(slot1);

	const classificacao = render(() => {
		const showGrupo = !props.geral && (props.fase.has_grupo > 0 );
		const deSelectCell = function() {
			setState({ ...state, selectClube: null, selectCell: null });
		};

		if (true) {
			state.classificacao.sort(function(a, b) {
				let result = a["nome_grupo"].localeCompare(b["nome_grupo"]);
				if (result !== 0) {
					return result;
				}
				a["nome_clube"] = props.clubeMap[a["id_clube"]]?.name;
				b["nome_clube"] = props.clubeMap[b["id_clube"]]?.name;
				return a["nome_clube"].localeCompare(b["nome_clube"]);
			});
		}

		const sortTabela = function(e, field) {
			let classificacao = state.classificacao.concat([]);
			let descending = false;
			if (state.sort === field) {
				descending = !state.descending;
			}
			classificacao.sort(function(a, b) {
				if (showGrupo) {
					let result = a["nome_grupo"].localeCompare(b["nome_grupo"]);
					if (result !== 0) {
						return result;
					}
				}
				if (parseFloat(a[field]) === parseFloat(b[field])) {
					return 0;
				}
				return (descending ? -1 : 1) * (parseFloat(a[field]) < parseFloat(b[field]) ? -1 : 1);
			});
			setState({ ...state, selectCell: null, selectClube: null, classificacao: classificacao, sort: field, descending: descending });

			e.stopPropagation();
		}
		let last_grupo = null;
		let last_obs_grupo = null;
		let por_grupo = true;
		let obs_pp = [];

		return (
			<div onClick={deSelectCell} className={(state.has_publico ? "publico " : "") + "classificacao column"}>
				<div>
					{showGrupo ? null : (<ClassificacaoHeader isSimulado={props.simulados !== undefined} has_publico={state.has_publico} sort={state.sort} descending={state.descending} sortTabela={sortTabela}/>)}
					{state.classificacao.map((item, i) => {
						let header = [];
						if (showGrupo && item.nome_grupo !== last_grupo && por_grupo) {
							header.push(obs_pp.map((obs) => <div className="row obs-pp"><div>{obs}</div></div>));
							obs_pp = [];
							if (last_obs_grupo) {
								header.push(<div className="row obs-grupo"><div>{last_obs_grupo}</div></div>);
							}
							last_grupo = item.nome_grupo;
							header.push(<div key={last_grupo} className="row column-header"><div className="e0">{last_grupo}</div></div>);
							header.push(<ClassificacaoHeader key={last_grupo + "-header"} isSimulado={props.simulados !== undefined} has_publico={state.has_publico} sort={state.sort} descending={state.descending} sortTabela={sortTabela}/>);
						}
						last_obs_grupo = item.obs_grupo;
						if (item.obs_pp) {
							obs_pp.push(item.obs_pp);
						}
						const selectCell = function(e, property) {
							setState({ ...state, selectClube: parseInt(item.id_clube), selectCell: property });
							e.stopPropagation();
						};
						const thisSelected = (props.jogoDetail && state.selectClube === parseInt(item.id_clube));
						const breakGroup = (i === state.classificacao.length-1 || (showGrupo && state.classificacao[i+1].nome_grupo != last_grupo));

						let classRow = "";
						if (props.simulados !== undefined) {
							if (item.posicao === 1 && props.primeira_posicao[item.id_grupo] == item.id_clube) {
								classRow = "primeira_posicao";

							} else if (item.posicao === 2 && props.segunda_posicao[item.id_grupo] == item.id_clube) {
								classRow = "segunda_posicao";
							}
						}

						return (
							<Fragment key={item.id_clube}>
								{header}
								<div className={"row line " + item.cor + (!thisSelected && breakGroup ? " last" : "") + " " + classRow}>
									<div className="fixed row">
										<div className="e0 posicao">{item.posicao}&ordm;</div>
										<Clube clubeMap={props.clubeMap} clube={item.id_clube} className="e100" />
										<div onClick={(e) => selectCell(e,"pg")} className={"clickable number" + (thisSelected && state.selectCell === "pg" ? " selected-cell" : "")}>{item.pg}</div>
									</div>
									<div onClick={(e) => selectCell(e, "jg")} className={"clickable number" + (thisSelected && state.selectCell === "jg" ? " selected-cell" : "")}>{item.jg}</div>
									<div onClick={(e) => selectCell(e, "vi")} className={"clickable number" + (thisSelected && state.selectCell === "vi" ? " selected-cell" : "")}>{item.vi}</div>
									<div onClick={(e) => selectCell(e, "em")} className={"clickable number" + (thisSelected && state.selectCell === "em" ? " selected-cell" : "")}>{item.em}</div>
									<div onClick={(e) => selectCell(e, "de")} className={"clickable number" + (thisSelected && state.selectCell === "de" ? " selected-cell" : "")}>{item.de}</div>
									<div onClick={(e) => selectCell(e, "gp")} className={"clickable number" + (thisSelected && state.selectCell === "gp" ? " selected-cell" : "")}>{item.gp}</div>
									<div onClick={(e) => selectCell(e, "gc")} className={"clickable number" + (thisSelected && state.selectCell === "gc" ? " selected-cell" : "")}>{item.gc}</div>
									<div className="number">{item.sg}</div>
									<div className="number percent">{generic.fmtPercent(item.apr)}</div>
									{state.has_publico ? (
										<>
											<div onClick={(e) => selectCell(e, "pu")} className={"clickable pu number large" + (thisSelected && state.selectCell === "pu" ? " selected-cell" : "")}>{generic.fmtNumber(item.pu)}</div>
											<div onClick={(e) => selectCell(e, "in")} className={"clickable number large" + (thisSelected && state.selectCell === "in" ? " selected-cell" : "")}>{generic.fmtNumber(item["in"])}</div>
											<div className="number percent">{generic.fmtPercent(item.iv)}</div>
											<div onClick={(e) => selectCell(e, "rl")} className={"clickable number currency" + (thisSelected && state.selectCell === "rl" ? " selected-cell" : "")}>{generic.fmtCurrency(item.rl)}</div>
											<div onClick={(e) => selectCell(e, "rb")} className={"clickable number currency" + (thisSelected && state.selectCell === "rb" ? " selected-cell" : "")}>{generic.fmtCurrency(item.rb)}</div>
										</>
									) :
										null
									}
									{props.simulados !== undefined ? <>
										<label className="select_column"><input onChange={() => props.updateGrupoVencedor(1, item.id_grupo, item.id_clube)} type="radio" name={"radio-1-" + last_grupo} checked={item.posicao === 1 && props.primeira_posicao[item.id_grupo] == item.id_clube} value="1"/></label>
										<label className="select_column"><input onChange={() => props.updateGrupoVencedor(2, item.id_grupo, item.id_clube)} type="radio" name={"radio-2-" + last_grupo} checked={item.posicao === 2 && props.segunda_posicao[item.id_grupo] == item.id_clube} value="2"/></label>
									</> : null}
								</div>
								{thisSelected ?
									<JogoDetail
										clubeMap={props.clubeMap}
										campeonato={props.campeonato}
										fase={props.fase}
										rodada={props.rodada}
										id_clube={state.selectClube}
										property={state.selectCell}
										/>
								:
									null
								}
							</Fragment>
						);
					})}
					{obs_pp.map((obs) => <div className="row obs-pp"><div>{obs}</div></div>)}
					{last_obs_grupo ? <div className="row obs-grupo"><div>{last_obs_grupo}</div></div> : null}
				</div>
				<div className="footnote">{props.footnote}</div>
				<div className="footnote"><a href="mailto:jornalismo@srgoool.com.br?subject=Reportar%20erro"><button>Reportar erro</button></a></div>
			</div>
		);
	});

	return (
		<>
			{classificacao}
			{dfp}
		</>
	)
}
